import { render, staticRenderFns } from "./MarketCreate.vue?vue&type=template&id=4e9a5bdc&scoped=true&"
import script from "./MarketCreate.vue?vue&type=script&lang=js&"
export * from "./MarketCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9a5bdc",
  null
  
)

export default component.exports